<template>
  <div class="download-select">
    <el-form :model="form" inline>
      <!-- 日期年 -->
      <el-form-item :label="$t('837')" v-if="[3, 5, 6].includes(type)">
        <el-date-picker
          v-model="form.year"
          value-format="yyyy"
          type="year"
          :placeholder="$t('838')"
          :picker-options="type === 5 || type === 6 ? pickerOptions : {}"
        ></el-date-picker>
      </el-form-item>
      <!-- 日期月 -->
      <el-form-item :label="$t('634')" v-if="![3, 5, 6].includes(type)">
        <el-date-picker
          v-model="form.month"
          value-format="yyyy-MM"
          type="month"
          :placeholder="$t('634')"
        ></el-date-picker>
      </el-form-item>
      <!-- 部门 -->
      <el-form-item :label="$t('19')" v-if="type === 3">
        <Dep :change="changeDep" :mprop="{ checkStrictly: true }" />
      </el-form-item>
      <el-form-item>
        <!-- 查询 -->
        <el-button type="primary" @click="search" v-if="type !== 5 && type !== 6" :disabled="!disabled">{{
          $t('80')
        }}</el-button>
        <!-- 导出Excel -->
        <el-button type="primary" :disabled="disBtn" @click="download" v-if="![6, 5].includes(type)">{{
          $t('export_excel')
        }}</el-button>
        <!-- 导出PDF -->
        <el-button type="primary" :disabled="disBtn" @click="downloadPdf(type)" v-if="[2, 5, 6, 8].includes(type)">{{
          $t('1306')
        }}</el-button>
        <!-- 导出TXT -->
        <el-button type="primary" :disabled="disBtn" @click="downloadTxt(type)" v-if="[1, 2, 6, 8].includes(type)">{{
          $t('1307')
        }}</el-button>
      </el-form-item>
      <el-form-item v-if="type === 2">
        <i class="el-icon-question"></i>
        <span @click="dialogVisible = true">{{ $t('1308') }}</span>
      </el-form-item>
    </el-form>
    <!-- 列表 -->
    <div>
      <el-table :data="tableData" style="width: 100%" border>
        <!-- <template v-if="type === 7">
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column fixed="right" :label="$t('70')">
            <template slot-scope="scope">
              <el-button @click.native.prevent="deleteRow(scope.$index, tableData)" type="text" size="small">
                {{ $t('1373') }}
              </el-button>
            </template>
          </el-table-column>
        </template> -->
        <el-table-column
          v-for="(key, value, index) in tableColumn"
          :key="index"
          :prop="value"
          :label="key"
          width="180"
        />
      </el-table>
    </div>
    <el-dialog :title="$t('1309')" :visible.sync="dialogVisible">
      <el-image
        v-if="$store.state.settings.curLang.key === 'zh'"
        :src="images[0]"
        :previewSrcList="[images[0]]"
      ></el-image>
      <el-image
        v-if="$store.state.settings.curLang.key === 'en'"
        :src="images[1]"
        :previewSrcList="[images[1]]"
      ></el-image>
      <el-image
        v-if="$store.state.settings.curLang.key === 'th'"
        :src="images[2]"
        :previewSrcList="[images[2]]"
      ></el-image>
    </el-dialog>
  </div>
</template>

<script>
import {
  taxExportMonth,
  socialExportMonth,
  taxGetMonthList,
  SocialGetMonthList,
  staffInfoList,
  staffInfoExcel,
  downloadPdf,
  downloadTawiPdf,
  downloadMonthTxt,
  downloadPNDTxt,
  downloadKorTxt,
  downloadKorPdf,
  exportMonth,
  getMonthList,
  getPnd3MonthList,
  exportPnd3Excel,
  downloadPnd3PDF,
  downloadPnd3TXT
} from 'api/payroll/prove-download'

import Dep from '@/components/department'
// 根据类型请求不同的接口
const requestMaps = new Map([
  [1, { excel: socialExportMonth, list: SocialGetMonthList }],
  [2, { excel: taxExportMonth, list: taxGetMonthList }],
  [3, { excel: staffInfoExcel, list: staffInfoList }],
  [4, { excel: exportMonth, list: getMonthList }],
  // 新增PDN3接口映射
  [8, { excel: exportPnd3Excel, list: getPnd3MonthList }]
])
const images = [require('@/assets/img/Chinese.png'), require('@/assets/img/en.png'), require('@/assets/img/th.png')]
export default {
  components: {
    Dep
  },
  props: {
    /**
     *  @description
     *  1 SorPorSor
     *  2 PND.1
     *  3 员工信息表
     *  4 Provident Fund Report
     *  5 withholding tax certificate（50 Tawi)
     *  6 PND1 Kor
     *  7 员工证明
     *  8 PND3
     */
    type: {
      default: false
    }
  },
  data() {
    return {
      pickerOptions: {
        disabledDate(time) {
          return time.getFullYear() > new Date().getFullYear() - 1
        }
      },
      form: {
        year: this.type === 5 || this.type === 6 ? (new Date().getFullYear() - 1).toString() : '',
        month: '',
        dept_id: ''
      },
      tableData: [],
      tableColumn: [],
      dialogVisible: false,
      images
    }
  },
  computed: {
    requestData() {
      return requestMaps.get(Number(this.type))
    },
    disabled() {
      const { year, month } = this.form
      return Boolean(this.type === 3 ? year : month)
    },
    disBtn() {
      const { month, year } = this.form
      if ([5, 6].includes(this.type)) {
        return !year
      }
      return [1, 2, 8].includes(this.type) && !month
    },
    isPND3() {
      return this.type === 8
    }
  },
  methods: {
    search() {
      const { year, month, dept_id } = this.form
      const msg = {
        year: month ? month.split('-')[0] : year,
        dept_id,
        month: month
      }
      this.requestData.list(this.isPND3 ? month : msg).then(res => {
        this.tableColumn = res.data.header
        this.tableData = res.data.body
      })
    },
    // 下载
    async download() {
      const { year, month, dept_id } = this.form
      const res = await this.requestData.excel(this.isPND3 ? month : { month, year, dept_id })
      window.location.href = res.data.down_load_excel.object_url
    },
    changeDep(a) {
      this.form.dept_id = a[0] && a[0].department_id
    },
    // 下载PDF
    async downloadPdf(type) {
      if (type === 5) {
        const res = await downloadTawiPdf({ year: this.form.year })
        if (res.code === 1) this.$message.success(res.message)
      }
      if (type === 2) {
        const res = await downloadPdf({ month: this.form.month })
        if (res.code === 1) this.$message.success(res.message)
      }
      if (type === 6) {
        const res = await downloadKorPdf({ year: this.form.year })
        if (res.code === 1) this.$message.success(res.message)
      }
      if (this.isPND3) {
        const res = await downloadPnd3PDF(this.form.month)
        if (res.code === 1) this.$message.success(res.message)
      }
    },
    // 下载 TXT
    async downloadTxt(type) {
      if (type === 1) {
        if (this.form.month) {
          const res = await downloadMonthTxt({ month: this.form.month })
          if (res.code === 1) {
            this.$message.success(res.message)
            window.location.href = res.data.object_url
          }
        } else {
          this.$message.warning(this.$t('txt_info'))
        }
      }
      if (type === 2) {
        if (this.form.month) {
          const res = await downloadPNDTxt({ month: this.form.month })
          if (res.code === 1) {
            this.$message.success(res.message)
            window.location.href = res.data.object_url
          }
        } else {
          this.$message.warning(this.$t('txt_info'))
        }
      }
      if (type === 6) {
        if (this.form.year) {
          const res = await downloadKorTxt({ year: this.form.year })
          if (res.code === 1) {
            this.$message.success(res.message)
            window.location.href = res.data.object_url
          }
        } else {
          this.$message.warning(this.$t('txt_info'))
        }
      }
      if (this.isPND3) {
        if (this.form.month) {
          const res = await downloadPnd3TXT(this.form.month)
          if (res.code === 1) {
            this.$message.success(res.message)
            window.location.href = res.data.object_url
          }
        } else {
          this.$message.warning(this.$t('txt_info'))
        }
      }
    }
  }
}
</script>
